module.exports = __webpack_public_path__ + "static/province-6685ad67b3daacb1b5c5370eff074a64.png";